import Controller from '../../close_when_clicked_outside_controller';
import modalBoundary from '../../../util/modal_boundary';

const FOCUSABLE = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(', ');

export default class extends Controller {
  static targets = ['trigger', 'panel'];

  #releaseBoundary = null;

  toggle() {
    this._opened = !this._opened;
  }

  close() {
    this._opened = false;
  }

  isInside(target) {
    return super.isInside(target) || Boolean(this.#navToggle?.contains(target));
  }

  // Insurance only: Cache-Control: no-store keeps these pages out of the bfcache today.
  closeOnRestore(event) {
    if (event.persisted) {
      this.close();
    }
  }

  get _opened() {
    return this.element.classList.contains('is-open');
  }

  // The outside-click handler assigns on every document click, so events fire on changes only.
  set _opened(value) {
    if (value === this._opened) {
      return;
    }

    this.element.classList.toggle('is-open', value);
    this.triggerTarget.setAttribute('aria-expanded', String(value));
    this.#setBoundary(value);
    this.#moveFocus(value);
    this.dispatch(value ? 'open' : 'close');
  }

  // Only the sheet is modal. A popover sits beside its trigger and leaves the page usable,
  // so trapping there would be wrong. Released before #moveFocus: the trigger it hands
  // focus back to sits outside the panel.
  #setBoundary(opened) {
    this.#releaseBoundary?.();
    const backdrop = this.element.querySelector('.ui--sidenav--action-backdrop');
    this.#releaseBoundary =
      opened && this.element.classList.contains('is-sheet')
        ? modalBoundary(this.#sidenav ?? this.panelTarget, [backdrop, this.triggerTarget])
        : null;
  }

  get #sidenav() {
    return this.element.closest('.ui--sidenav');
  }

  get #navToggle() {
    return this.#sidenav?.querySelector('[data-ui--sidenav-target="toggle"]');
  }

  // The panel is a role="dialog", so opening has to take focus with it and closing has
  // to hand it back; otherwise Tab from the trigger walks the page behind the panel.
  #moveFocus(opened) {
    if (opened) {
      this.panelTarget.querySelector(FOCUSABLE)?.focus();
    } else if (this.element.contains(document.activeElement)) {
      this.triggerTarget.focus();
    }
  }
}
